export default "__VITE_ASSET__BrqZvGxf__"